"use strict";

stateProviders.push({
    name: "schoolside.email",
    url: "/email",
    templateUrl: "fast/submodules/schoolside/email/partials/email.html?v=" + versionNo,
    controller: "EmailBlastController",
	resolve: {
		cats: function(SchoolSubcategoriesModelService, authServiceFactory) {
			return SchoolSubcategoriesModelService.resolveData(authServiceFactory.getAuth().schoolID);
		},
        recipients: function(authServiceFactory, EmailBlastRecipientsModelService)
        {
            return EmailBlastRecipientsModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        currentYear: function(SchoolModelService, DateService, $q)
        {
            var deferred = $q.defer();
            if (SchoolModelService.get()[0]) {
                deferred.resolve(DateService.getCurrentYear())
            }
            else {
                SchoolModelService.resolveData().then(function(data) {
                    deferred.resolve(DateService.getCurrentYear());
                });
            }
            return deferred.promise;
        }
	}
});